module.exports = __webpack_public_path__ + "assets/img/one-tab1-on.640d7a19.png";